document.addEventListener('DOMContentLoaded', () => {
  console.log("Page loaded. Setting up observer for Recharge widget.");

  // Define a mapping of variant IDs to their respective discount percentages
  const variantDiscountMapping = {
    "template--17495810375847__main-1-1": 31, // Nella 3 30-Day Packs
    "template--17495810441383__main-1-1": 31, // V-Nella 3 30-Day Packs
    // Add new IDs and their respective percentages when available
    // "template--newIDfor6MonthOffer1": 25,  // Example ID for 6-month offering with 25% discount
    // "template--newIDfor6MonthOffer2": 20   // Example ID for another 6-month offering with 20% discount
  };

  function roundPrices() {
    const priceElements = document.querySelectorAll('.discount-label, .price-label');
    let pricesUpdated = false;

    priceElements.forEach(priceElement => {
      let priceText = priceElement.innerText;

      if (priceText.includes('%')) {
        let percentage = parseFloat(priceText.replace(/[^\d.,-]/g, '').replace(',', '.'));

        // Get the selected variant's ID
        const selectedVariantId = document.querySelector('input[type="radio"][name="Size"]:checked')?.id;

        // Check if the selected variant ID has a specific discount percentage
        if (selectedVariantId && variantDiscountMapping[selectedVariantId] !== undefined) {
          const targetPercentage = variantDiscountMapping[selectedVariantId];
          priceElement.innerText = priceText.replace(/\d+(\.\d+)?%/, `${targetPercentage}%`);
        } else if (!isNaN(percentage)) {
          let roundedPercentage = Math.round(percentage);
          priceElement.innerText = priceText.replace(/\d+(\.\d+)?%/, `${roundedPercentage}%`);
        }
        pricesUpdated = true;
      } else {
        let price = parseFloat(priceText.replace(/[^\d.,-]/g, '').replace(',', '.'));
        if (!isNaN(price)) {
          let roundedPrice = Math.round(price);
          priceElement.innerText = `$${roundedPrice}.00`;
          pricesUpdated = true;
        }
      }

      // Show the price elements only after rounding
      priceElement.style.visibility = 'visible';
    });

    return pricesUpdated;
  }

  // Initial price rounding
  roundPrices();

  // Set up MutationObserver
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (node.matches('.rc-container') || node.querySelector('.discount-label, .price-label'))) {
              console.log("Recharge widget or price elements added/modified. Rounding prices.");
              roundPrices();
            }
          });
        }
      }
      if (mutation.type === 'characterData' && mutation.target.parentNode.matches('.discount-label, .price-label')) {
        console.log("Price label text modified. Rounding prices.");
        roundPrices();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true });

  // Listen for clicks on variant radio buttons
  const variantRadioButtons = document.querySelectorAll('input[type="radio"][name="Size"]');
  variantRadioButtons.forEach(button => {
    button.addEventListener('click', () => {
      console.log("Variant radio button clicked. Hiding prices and starting polling...");

      // Hide the price elements immediately
      const priceElements = document.querySelectorAll('.discount-label, .price-label');
      priceElements.forEach(priceElement => {
        priceElement.style.visibility = 'hidden';
      });

      // Start polling for price updates
      const pollingInterval = setInterval(() => {
        console.log("Polling for updated prices...");
        if (roundPrices()) {
          // If prices have been updated and rounded, stop polling
          clearInterval(pollingInterval);
          console.log("Prices updated and rounded. Stopping polling.");
        }
      }, 20); // Check every 20 milliseconds
    });
  });
});

